import { createRef, ReactElement, useMemo } from 'react'
import { Textarea } from '@machobear/design-system'
import { useField } from 'formik'
import noop from 'lodash/noop'

import useFocusOnError from '@/hooks/use-focus-on-error'

export const TextAreaField = ({
  name,
  label,
  onChange = noop,
  onBlur = noop,
  required = false,
  disabled = false,
  characterLimit = 500,
  lines = 4
}: {
  name: string
  label: string
  onChange?: any
  onBlur?: any
  required?: boolean
  disabled?: boolean
  characterLimit?: number
  lines?: number
}) => {
  const fieldRef = createRef<HTMLTextAreaElement>()
  const [field, meta] = useField(name)
  const { error, touched } = meta
  const { value, onChange: formikOnChange, onBlur: formikOnBlur } = field
  useFocusOnError({ fieldRef, name })

  const onChangeField = (e: any) => {
    onChange(e)
    formikOnChange(e)
  }

  const onBlurField = (e: any) => {
    onBlur(e)
    formikOnBlur(e)
  }

  return (
    <Textarea
      ref={fieldRef}
      id={name}
      name={name}
      value={value}
      onChange={onChangeField}
      onBlur={onBlurField}
      label={label}
      required={required}
      disabled={disabled}
      message={error && touched ? error : null}
      tone={error && touched ? 'critical' : 'neutral'}
      placeholder={label}
      characterLimit={characterLimit}
      resize={false}
      lines={lines}
      lineLimit={lines}
      grow={true}
    />
  )
}
